module.exports = __webpack_public_path__ + "img/pic.8b8dafbf.png";